import { Button } from "@/components/ui/button";
import { useAuth } from "@/auth/useAuth";
interface EmailPreviewProps {
  personalMessage: string;
  newsletterName?: string;
}

export const EmailPreview = ({
  personalMessage,
  newsletterName = "My Newsletter",
}: EmailPreviewProps) => {
  const { user } = useAuth();
  console.log(user);
  return (
    <div className="border rounded-lg p-4 bg-gray-50">
      <h3 className="text-sm font-medium mb-2">Preview Email</h3>
      <div className="bg-white rounded-lg p-4 shadow-sm">
        <p className="text-sm font-medium mb-2">Join me on {newsletterName}!</p>

        <p className="text-sm text-gray-600 mb-3">Hi there,</p>

        <p className="text-sm text-gray-600 mb-3">
          {user?.user_metadata?.full_name || user?.email} started a newsletter
          about AI news and would love for you to be part of it.
          {personalMessage && (
            <p className="text-sm text-gray-600 mb-3 whitespace-pre-wrap bg-gray-50 p-3 rounded italic">
              "{personalMessage}"
            </p>
          )}
        </p>
        <p className="text-sm text-gray-600 mb-3">
          Here's a sample of what you'll receive:
        </p>

        <div className="bg-gray-50 p-3 rounded">
          <p className="text-sm font-medium">Newsletter Details:</p>
          <p className="text-sm text-gray-600">
            [Newsletter preview content will go here]
          </p>
        </div>
        <Button className="mt-4 w-full" variant="secondary">
          Subscribe to Newsletter
        </Button>
      </div>
    </div>
  );
};
